<template>
  <HomeEnglish v-if="currentLang === 'en'" @switch-language="switchLang" />
  <div v-else class="hello">
    
    <div class="main-bg">
      <img
        v-for="(img, i) in carouselImages"
        :key="i"
        :src="img"
        class="carousel-img"
        :class="{ active: currentSlide === i }"
        alt=""
      >
    </div>
    <div class="top">
      <img class="logo" src="../assets/imgs/logo@2x.png" alt="">
      <div class="language">
        <div class="lang-switch" @click="toggleLang">
          <span>中文</span>
          <span class="arrow"></span>
          <ul v-show="showDropdown" class="lang-dropdown">
            <li @click.stop="switchLang('zh')">中文</li>
            <li @click.stop="switchLang('en')">English</li>
          </ul>
        </div>
        <span class="divider"></span>
        <img class="search-icon" src="../assets/imgs/图层 925@2x.png" alt="" @click="showSearch = !showSearch">
        <div v-if="showSearch" class="search-bar">
          <input v-model="searchText" type="text" class="search-input" placeholder="搜索..." @keydown.enter="doSearch">
          <span class="search-btn" @click="doSearch">搜索</span>
        </div>
      </div>
      <div class="weather top-item">
        <img src="../assets/imgs/组 18@2x.png" alt="">
        <div class="info">
          <div class="main-info">
            <div class="status">{{ weather.weather }} {{ weatherIcon }}</div>
            <div class="label">{{ weather.temperature }}°</div>
          </div>
          <div class="desc-info">景区天气</div>
        </div>
      </div>
      <div class="time top-item">
        <img src="../assets/imgs/组 18@2x (3).png" alt="">
        <div class="info">
          <div class="main-info">动态游客量</div>
          <div class="desc-info marquee-wrap">
            <span class="marquee-text">景区今日最大承载量8.1万，瞬时最大承载量3.9万，景区在园人数{{ siteConfig.visitor_count || '--' }}人，舒适度为{{ siteConfig.comfort_level || '--' }}，预计明天接待游客：{{ siteConfig.expected_visitors || '--' }}人。</span>
          </div>
        </div>
      </div>
    </div>
    <div class="left">
      <div
        v-for="(item, index) in sidebarItems"
        :key="index"
        class="sidebar-item"
        @mouseenter="hoveredIndex = index"
        @mouseleave="hoveredIndex = -1"
        @click="handleSidebarClick(index)"
      >
        <img :src="hoveredIndex === index ? item.hoverSrc : item.src" alt="" class="sidebar-img">
        <div class="sidebar-label">{{ item.label }}</div>
      </div>
    </div>
    <div v-if="activeMenu !== 7 && showSun" class="right" >
      <div class="sun-container">
        <div class="sun-img-wrap">
          <img src="../assets/imgs/7月14日(2).gif" alt="" class="sun-img" @click="activeMenu = 7">
          <img src="../assets/imgs/图层 10.png" class="sun-close" @click.stop="showSun = false">
          <img :src="voiceOn ? require('../assets/imgs/图层 62@2x.png') : require('../assets/imgs/图层 63@2x.png')" class="voice-toggle" @click.stop="toggleVoice">
        </div>
      </div>
    </div>
    <img v-if="activeMenu !== 7 && !showSun" :src="require('../assets/imgs/组 1.png')" class="sun-collapsed" @click="showSun = true">
    <audio ref="sunAudio" :src="sunAudioSrc" @ended="onAudioEnded"></audio>
    <div class="main-contain">
      <div class="menu">
        <div
          v-for="(item, index) in menuList"
          :key="index"
          class="menu-item"
          :class="{ active: activeMenu === index }"
          @click="selectMenu(index)"
        >{{ item }}</div>
      </div>
      <HomeContent v-if="activeMenu === 0" :key="'home-' + menuKey" @go-menu="handleGoMenu" />
      <ZouJinHuaguo v-if="activeMenu === 1" :key="'zj-' + menuKey" :defaultArticle="zjArticle" :defaultSection="zjSection" @go-home="activeMenu = 0" />
      <NewsSection v-if="activeMenu === 2" :key="'news-' + menuKey" :tab="newsTab" :article="newsArticle" @go-home="activeMenu = 0" />
      <GovSection v-if="activeMenu === 3" :key="'gov-' + menuKey" :defaultSection="govDefaultSection" :defaultArticle="govArticle" @go-home="activeMenu = 0" />
      <TravelGuide v-if="activeMenu === 4" :key="'guide-' + menuKey" :defaultArticle="guideArticle" @go-home="activeMenu = 0" />
      <ServiceSection v-if="activeMenu === 7" :key="'svc-' + menuKey" @go-home="activeMenu = 0" />
      <SearchSection v-if="activeMenu === 8" :initial-query="searchQuery" @go-home="activeMenu = 0" />
    </div>
  </div>
</template>

<script>
  import HomeEnglish from './HomeEnglish.vue'
import HomeContent from './HomeContent.vue'
import ZouJinHuaguo from './ZouJinHuaguo.vue'
import NewsSection from './NewsSection.vue'
import GovSection from './GovSection.vue'
import TravelGuide from './TravelGuide.vue'
import ServiceSection from './ServiceSection.vue'
import SearchSection from './SearchSection.vue'
import FooterContent from '@/components/Footer.vue'
import { currentLang } from '../utils/lang'
import { getConfig, getWeather } from '../api/index'
import img1 from '../assets/imgs/大图1.png'
import img2 from '../assets/imgs/大图2.png'
import img3 from '../assets/imgs/大图3.png'
import img4 from '../assets/imgs/大图4.png'

export default {
  name: 'HelloWorld',
  components: {
    HomeEnglish,
    HomeContent,
    ZouJinHuaguo,
    NewsSection,
    GovSection,
    TravelGuide,
    ServiceSection,
    SearchSection,
    FooterContent,
  },
  data() {
    return {
      currentLang: currentLang.value || 'zh',
      showDropdown: false,
      activeMenu: 0,
      newsTab: 0,
      newsArticle: null,
      govArticle: null,
      govDefaultSection: '',
      govTab: 0,
      zjArticle: null,
      zjSection: '',
      guideArticle: null,
      showSun: true,
      showSearch: false,
      searchText: '',
      searchQuery: '',
      hoveredIndex: -1,
      voiceOn: false,
      sunAudioSrc: require('../assets/imgs/output.mp3'),
      sunText: '欢迎您来到花果山景区，俺是小圣！时刻在您身边提供旅游服务咨询，伴您尽享西游故里之美。',
      textIndex: 0,
      textTimer: null,
      menuKey: 0,
      siteConfig: {},
      weather: { weather: '晴', temperature: '12°~20°' },
      carouselImages: [img1, img2, img3, img4],
      currentSlide: 0,
    }
  },
  computed: {
    visibleText() {
      return this.sunText.substring(0, this.textIndex)
    },
    weatherIcon() {
      const w = this.weather.weather || ''
      if (w.includes('雨')) return '🌧'
      if (w.includes('雪')) return '❄'
      if (w.includes('云') || w.includes('阴')) return '⛅'
      if (w.includes('雾') || w.includes('霾')) return '🌫'
      return '☀'
    },
    menuList() {
      return ['网站首页', '走进花果山', '景区资讯', '政务资讯', '旅游攻略', '语音导览', 'VR景区', '服务咨询']
    },
    sidebarItems() {
      return [
        { label: '团队预约', src: require('../assets/imgs/导游预约@2x (1).png'), hoverSrc: require('../assets/imgs/导游预约@2x.png') },
        { label: 'VR景区', src: require('../assets/imgs/VR景区@2x (4).png'), hoverSrc: require('../assets/imgs/VR景区@2x (3).png') },
        { label: '评价投诉', src: require('../assets/imgs/问卷调查@2x (1).png'), hoverSrc: require('../assets/imgs/问卷调查@2x.png') },
        { label: '语音导览', src: require('../assets/imgs/游览预约@2x (3).png'), hoverSrc: require('../assets/imgs/游览预约@2x (2).png') },
      ]
    },
  },
  watch: {
    activeMenu() {
      this.$nextTick(() => { window.scrollTo(0, 0) })
    },
    '$route.query.menu': function(val) {
      const idx = val === undefined ? 0 : parseInt(val)
      if (!isNaN(idx) && idx !== this.activeMenu && idx >= 0 && idx <= 7 && idx !== 5 && idx !== 6) {
        this.setMenuState(idx)
      }
    },
  },
  mounted() {
    const routeQuery = this.$route.query
    const menuFromUrl = parseInt(routeQuery.menu)
    if (!isNaN(menuFromUrl) && menuFromUrl >= 0 && menuFromUrl <= 7 && menuFromUrl !== 5 && menuFromUrl !== 6) {
      this.activeMenu = menuFromUrl
      this.menuKey++
      if (routeQuery.zjSection) this.zjSection = routeQuery.zjSection
      if (routeQuery.zjArticle) this.zjArticle = { id: routeQuery.zjArticle }
      if (routeQuery.newsArticle) this.newsArticle = { id: routeQuery.newsArticle }
      if (routeQuery.newsTab) this.newsTab = parseInt(routeQuery.newsTab)
      if (routeQuery.govSection) this.govDefaultSection = routeQuery.govSection
      if (routeQuery.govTab !== undefined) {
        this.govTab = parseInt(routeQuery.govTab)
        const tabSectionMap = ['新闻资讯', '政务信息', '政务公开', '政策法规']
        this.govDefaultSection = tabSectionMap[this.govTab] || ''
      }
      if (routeQuery.govArticle) this.govArticle = { id: routeQuery.govArticle }
      if (routeQuery.guideArticle) this.guideArticle = { id: routeQuery.guideArticle }
    }
    this.$nextTick(() => this.playSunAudio())
    const play = () => { this.playSunAudio(); document.removeEventListener('pointerdown', play) }
    document.addEventListener('pointerdown', play, { once: true })
    this.fetchSiteConfig()
    this.fetchWeather()
    this.timer = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.carouselImages.length
    }, 3000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.textTimer)
  },
  methods: {
    async fetchSiteConfig() {
      try {
        const res = await getConfig()
        if (res.code === 200 && res.data) {
          this.siteConfig = res.data
        }
      } catch (e) {
        console.error('获取站点配置失败:', e)
      }
    },
    async fetchWeather() {
      try {
        const res = await getWeather()
        if (res.code === 200 && res.data && res.data.lives && res.data.lives.length) {
          const live = res.data.lives[0]
          this.weather = {
            weather: live.weather,
            temperature: live.temperature,
          }
        }
      } catch (e) {
        console.error('获取天气失败:', e)
      }
    },
    toggleLang() {
      this.showDropdown = !this.showDropdown
    },
    switchLang(lang) {
      localStorage.setItem('hgs_lang', lang)
      if (lang === 'en') {
        window.open(window.location.origin + '/?menu=0', '_blank')
        return
      }
      this.currentLang = lang
      currentLang.value = lang
      this.showDropdown = false
      this.$router.replace({ query: { menu: 0 } }).catch(() => {})
    },
    doSearch() {
      const q = this.searchText.trim()
      if (q) {
        this.searchQuery = q
        this.activeMenu = 8
        this.showSearch = false
        this.searchText = ''
      }
    },
    selectMenu(index) {
      if (index === 5) {
        window.open('/#/audio-guide', '_blank')
        return
      }
      if (index === 6) {
        const url = this.siteConfig.vr_tour_url || this.siteConfig.vrTourUrl || 'http://www.0518720.com/tour/e4aed3f96c9359f3'
        if (url) window.open(url, '_blank')
        return
      }
      this.setMenuState(index)
      this.$router.push({ query: { menu: index } }).catch(() => {})
    },
    setMenuState(index) {
      this.activeMenu = index
      this.menuKey++
      this.newsTab = 0
      this.newsArticle = null
      this.govArticle = null
      this.govDefaultSection = ''
      this.zjArticle = null
      this.zjSection = ''
      this.guideArticle = null
    },
    handleGoMenu(payload) {
      this.newsArticle = null
      this.govArticle = null
      this.govDefaultSection = ''
      this.zjArticle = null
      this.zjSection = ''
      this.guideArticle = null
      if (payload && typeof payload === 'object') {
        this.activeMenu = payload.menu
        if (payload.menu === 1) {
          this.zjArticle = payload.article || null
          this.zjSection = payload.section || ''
        }
        if (payload.menu === 2) this.newsArticle = payload.article || null
        if (payload.menu === 3) {
          this.govDefaultSection = payload.section || ''
          this.govArticle = payload.article || null
          const tabMap = { '新闻资讯': 0, '政务信息': 1, '政务公开': 2, '政策法规': 3 }
          this.govTab = tabMap[payload.section] || 0
        }
        if (payload.menu === 4) this.guideArticle = payload.article || null
        if (payload.menu === 5) { window.open('/#/audio-guide', '_blank'); return }
        if (payload.menu === 6) {
          const url = this.siteConfig.vr_tour_url || this.siteConfig.vrTourUrl || 'http://www.0518720.com/tour/e4aed3f96c9359f3'
          if (url) window.open(url, '_blank')
          return
        }
      } else {
        this.activeMenu = payload
      }
      this.menuKey++
      this.$router.replace({ query: { menu: this.activeMenu } }).catch(() => {})
      this.newsTab = 1
    },
    handleSidebarClick(index) {
      if (index === 0) {
        window.open('http://team.lyghgs.cn/background/index.html#/login?redirect=%2Fdashboard', '_blank')
      }
      if (index === 1) {
        window.open('http://www.0518720.com/tour/e4aed3f96c9359f3', '_blank')
      }
      if (index === 2) {
        window.open('https://web.youlyg.com/commentnav/#/pages/index/index', '_blank')
      }
      if (index === 3) {
        window.open('/#/audio-guide', '_blank')
      }
    },
    startText() {
      this.textIndex = 0
      clearInterval(this.textTimer)
      this.textTimer = setInterval(() => {
        if (this.textIndex < this.sunText.length) {
          this.textIndex++
        } else {
          clearInterval(this.textTimer)
        }
      }, 250)
    },
    stopText() {
      clearInterval(this.textTimer)
    },
    toggleVoice() {
      this.voiceOn = !this.voiceOn
      const audio = this.$refs.sunAudio
      if (!audio) return
      if (this.voiceOn) {
        audio.currentTime = 0
        audio.play().catch(() => {})
        this.startText()
      } else {
        audio.pause()
        this.stopText()
      }
    },
    onAudioEnded() {
      this.voiceOn = false
      this.stopText()
      this.textIndex = this.sunText.length
    },
    playSunAudio() {
      if (!this.voiceOn) return
      const audio = this.$refs.sunAudio
      if (audio) {
        audio.currentTime = 0
        audio.play().catch(() => {})
      }
    },
  },
}
</script>

<style scoped lang="less">
  .hello{
    background-color: #E7EFF6;
    padding-bottom: 0.6rem;
    position: relative;
    border-top: 1px solid transparent;
    .main-bg{
      width: 100vw;
      height: 7.83rem;
      position: absolute;
      left: 0;
      z-index: 0;
      overflow: hidden;
      .carousel-img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.8s ease;
        &.active{
          opacity: 1;
        }
      }
    }
    .top{
      width: 100%;
      height: 1.11rem;
      background-color: rgba(0, 0, 0, .4);
      padding: 0 0 0 3.4rem;
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 9;
      .logo{
        width: 2.17rem;
        height: auto;
      }
      .language{
        position: relative;
        display: flex;
        align-items: center;
        margin-left: .52rem;
        margin-right: .8rem;
        .divider{
          display: inline-block;
          width: 1px;
          height: 0.19rem;
          background: rgba(255,255,255,.3);
          margin: 0 0.2rem;
        }
        .search-icon{
          width: .25rem;
          height: auto;
          cursor: pointer;
        }
        .lang-switch{
          position: relative;
          color: #F9F8F7;
          font-size: .225rem;
          cursor: pointer;
          user-select: none;
          .arrow{
            display: inline-block;
            width: 0;
            height: 0;
            margin-left: 0.1rem;
            border-left: 0.06rem solid transparent;
            border-right: 0.06rem solid transparent;
            border-top: 0.08rem solid #fff;
            vertical-align: middle;
          }
          .lang-dropdown{
            position: absolute;
            top: 100%;
            right: 0;
            background: #fff;
            color: #333;
            list-style: none;
            padding: 0.1rem 0;
            margin: 0.1rem 0 0;
            border-radius: 0.1rem;
            min-width: 1.6rem;
            box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,.2);
            li{
              padding: 0.15rem 0.4rem;
              cursor: pointer;
              &:hover{
                background: #f0f0f0;
              }
            }
          }
        }
      }
      .top-item{
        color: #fff;
        display: flex;
        margin-left: .3125rem;
        img{
          width: 0.53rem;
          height: auto;
        }
        .info{
          margin-left: 0.13rem;
          .main-info{
            font-size: 0.22rem;
          }
          .desc-info{
            font-size: 0.13rem;
            margin-top: 0.02rem;
            &.marquee-wrap{
              .marquee-text{
              }
            }
          }
        }
      }
      .weather{
        .main-info{
          display: flex;
          align-items: center;
          .weather-icon{
            width: 0.23rem;
            height: 0.22rem;
            margin: 0 0.02rem;
          }
        }
      }
    }
    .search-bar{
      position: absolute;
      right: -2rem;
      bottom: -1.04rem;
      z-index: 10;
      display: flex;
      background: #fff;
      border-radius: 0.06rem;
      box-shadow: 0 0.04rem 0.12rem rgba(0,0,0,.15);
      padding: 0.1rem;
      .search-input{
        width: 3rem;
        height: 0.45rem;
        border: 1px solid #ccc;
        border-radius: 0.04rem;
        padding: 0 0.1rem;
        font-size: 0.18rem;
        outline: none;
        &:focus{ border-color: #369BF8; }
      }
      .search-btn{
        width: 0.7rem;
        text-align: center;
        height: 0.45rem;
        line-height: 0.45rem;
        background: #369BF8;
        color: #fff;
        border-radius: 0.04rem;
        margin-left: 0.1rem;
        font-size: 0.16rem;
        cursor: pointer;
        &:hover{ background: #1372C9; }
      }
    }
    .main-contain{
      width: 14.95rem;
      padding: 0.14rem;
      background-color: #fff;
      margin: 0 auto;
      margin-top: 5.7rem;
      position: relative;
      z-index: 1;
      .menu{
        display: flex;
        .menu-item{
          flex: 1;
          height: 0.78rem;
          line-height: 0.78rem;
          text-align: center;
          font-size: 0.29rem;
          color: #FAF9F8;
          background: #369BF8;
          cursor: pointer;
          border-right: 1px solid #1372C9;
          &:last-child{
            border-right: none;
          }
          &.active{
            background: #1372C9;
          }
        }
      }
    }
    .left{
      position: fixed;
      left: 1.5rem;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.15rem;
      .sidebar-item{
        cursor: pointer;
        text-align: center;
        position: relative;
        .sidebar-img{
          width: 0.82rem;
          height: 0.82rem;
          display: block;
        }
        .sidebar-label{
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0.15rem;
          font-size: 0.16rem;
          color: #fff;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
    .right{
      position: fixed;
      right: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      cursor: pointer;
      .sun-container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        .sun-close{
          position: absolute;
          top: 3.8rem;
          right: -0.05rem;
          width: 0.38rem;
          cursor: pointer;
          z-index: 11;
        }
        .sun-img-wrap{
          position: relative;
          display: inline-block;
          width: 2.3rem;
          .sun-img{
            width: 100%;
            display: block;
          }
          .voice-toggle{
            position: absolute;
            right: 0rem;
            bottom: 0.35rem;
            width: 0.35rem;
            cursor: pointer;
            z-index: 2;
          }
          .voice-icons{
            position: absolute;
            right: 0.3rem;
            bottom: 0.2rem;
            display: flex;
            gap: 0.05rem;
            .voice-icon{
              width: 0.32rem;
              height: auto;
              display: block;
              cursor: pointer;
            }
          }
        }
    }
  }
  .sun-collapsed{
    position: fixed;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.8rem;
    cursor: pointer;
    z-index: 100;
  }
}
@keyframes marquee{
  0%{ transform: translateX(0); }
  100%{ transform: translateX(-100%); }
}
</style>
